import { useFeatureFlag } from '~/shared/hooks/useFeatureFlag'

/**
 * Waffle flag gating the cross-domain member journey timeline in the Timeline tab. Ramped
 * per-user, independently of the design refresh; with it off the tab renders its legacy
 * event-log content.
 */
const FLAG_CRM_MEMBER_TIMELINE = 'crm.member_timeline'

export const useMemberTimeline = () => useFeatureFlag(FLAG_CRM_MEMBER_TIMELINE)

/**
 * Waffle flag gating the AI journey summary card above the feed. Separate from the timeline's
 * own flag so it ramps strictly after it, and per-user so one reviewer can read the output
 * before anyone else sees it.
 */
const FLAG_CRM_MEMBER_TIMELINE_SUMMARY = 'crm.member_timeline_summary'

export const useMemberTimelineSummary = () => useFeatureFlag(FLAG_CRM_MEMBER_TIMELINE_SUMMARY)
